import {HttpClient, HttpParams} from '@angular/common/http';
import { Injectable , ViewChild} from '@angular/core';
import { IApp } from '@core/models/app.interfaces';
import { environment } from '@env/environment';
import { UnitFilterModel } from '@core/models/filter.model';
import { IActionOptionsModel } from '@shared/models/table-filter.models';
import {
  ruRemittanceAction,
  remittanceAction, cancellationAction, suspensionAction, retirementAction, revocationAction,
  transferAction, statusUriMap
} from '@module/unit-management/components/unit-list/unit-list.const';
import { CreditFormComponent } from '@module/unit-management/components/credit-form/credit-form.component';
import { UnitManagementService } from '@module/unit-management/services/unit-management.service';
import { HelperService } from "@shared/services/helper.service";
import { Router } from '@angular/router';
import { ValudateDetailsToProceed } from '@core/models/submitPaymentRefund';
import { StoreService } from '@core/store/store.service';
import { Location } from '@angular/common';

export const CREDIT_SERVICE = '/obps-service';
export const PDF_PREVIEW = '/remittanceAction/submitReconizedUnitPdfPreview';

@Injectable({
  providedIn: 'root',
})
export class WizardService {
  @ViewChild('accountUserActions', {static: true}) public accountUserActions: CreditFormComponent;

  _steps: any;
  _current: any;
  _unitFilterState: UnitFilterModel = {};
  _obligationdata: IApp.IObligation;
  _currentData: any;
  codeType: string;
  _refundModeValues: ValudateDetailsToProceed;

  constructor( private http: HttpClient, private router: Router,
    private unitManagementService: UnitManagementService,
    private helperService: HelperService,
    private store: StoreService,
    private _location: Location
    ) { }

  get steps() {
    return this._steps;
  }

  set steps(data) {
    this._steps = data;
  }

  get current() {
    return this._current;
  }

  set current(step) {
    this._current = step;
  }

  get currentStep() {
    return this._steps[this._current];
  }

  set currentStep(data) {
    const step = this._steps[this._current];
    this._steps[this._current] = {...step, ...data};
  }

  get refundModeValues(){
    return this._refundModeValues;
  }

  set refundModeValues(data){
    this._refundModeValues = data;
  }

  nextStep() {
    if (this._steps.length >= this._current + 2) {
      this._currentData = this._steps[this._current].data;
      this._current = this._current + 1;
      if (this._current === 1) {
        this.onActionSelected(remittanceAction, this._currentData);
      }
    }else {
      this.submitCredit();
    }
  }

  previousStep(){
    if (this._current > 0) {
     this._current = this._current - 1;
     this._currentData = this._steps[this._current].data;
     if (this._current === 1) {
       // this.onActionSelected(remittanceAction, this._currentData);
      }
    }else {
      //this.submitCredit();
    }
  }

  get obligationData(): IApp.IObligation {
    return this._obligationdata;
  }

  setCodeType(codeType: string) {
    this.codeType = codeType;
  }


 getCodeType() {
   return this.codeType;
  }


  setObligationData(obligationdata: IApp.IObligation) {
    if (obligationdata) {
      this._obligationdata = obligationdata;
      this._unitFilterState.facilityNameList = [obligationdata.accountId];
      this._unitFilterState.unitStatusList = ['ACTIVE'];
    }
  }

  onActionSelected(action: IActionOptionsModel, selectedUnits:IApp.IUnitData[]) {
    const creditActionData = this.unitManagementService.onActionSelected(action, selectedUnits);
    if (this._obligationdata) {
      creditActionData.outstandingQuantity = this._obligationdata.outstandingObligation;
      creditActionData.obligationId = this._obligationdata.obligationId;
      creditActionData.complianceYear = this._obligationdata.compliancePeriod;
      creditActionData.regularRateDeadlineStr = this._obligationdata.regularRateDeadlineStr;
      window.history.state.data = creditActionData;
    }
  }

  submitCredit() {
     const obligationId = this._obligationdata.obligationId ? this._obligationdata.obligationId :
    this._currentData.model.obligationId;
    if(this._currentData && this._currentData.uri){
    this.unitManagementService.creditAction(`${this._currentData.uri}`, this._currentData.model).subscribe(
      result => {
        this._currentData.model = null;
        this._location.back();
        //this.router.navigate(this.helperService.getTranslatedPath(`/obligation-management/list/${obligationId}`));
      },
    );
    }else{
      this._location.back();
     // this.router.navigate(this.helperService.getTranslatedPath(`/obligation-management/list/${obligationId}`));
    }
  }

  setRefundData(data: any){
    const existingData = this._steps[this._current].data;
    this._steps[this._current].data = data;
    if(existingData){
      if(existingData.ruUnitList){
        data.ruUnitList = existingData.ruUnitList;
      }
      if(existingData.scrUnitList){
        data.scrUnitList = existingData.scrUnitList;
      }
      // if(existingData.paymentList ){
      //   data.paymentList = existingData.paymentList;
      // }
      if(existingData.obligationTable ){
        data.obligationTable = existingData.obligationTable;
      }
      if(existingData.itpRefNumberList ){
        data.itpRefNumberList = existingData.itpRefNumberList;
      }
      if(existingData.totalAllTables ){
        data.totalAllTables = existingData.totalAllTables;
      }
      if(existingData.payload ){
        data.payload = existingData.payload;
      }
      if(existingData.totalValues){
        data.totalValues = existingData.totalValues;
      }

    }
    const paymentListToSort = (existingData && existingData.paymentList) || data.paymentList;
    if (Array.isArray(paymentListToSort)) {
      data.paymentList = this.sortPaymentListByItpRefNum(paymentListToSort);
     }
    this.nextStep();
  }

  private sortPaymentListByItpRefNum(paymentList: any[]): any[] {
    return [...paymentList].sort((a, b) => {
      const aRef = a?.itpRefNum;
      const bRef = b?.itpRefNum;

      if (aRef == null && bRef == null) {
        return 0;
      }
      if (aRef == null) {
        return 1;
      }
      if (bRef == null) {
        return -1;
      }

      const aNum = Number(aRef);
      const bNum = Number(bRef);

      if (!Number.isNaN(aNum) && !Number.isNaN(bNum)) {
        return aNum - bNum;
      }

      return String(aRef).localeCompare(String(bRef), undefined, { numeric: true, sensitivity: 'base' });
    });
  }

  get currentData(): any {
    return this._currentData;
  }

  clearCurrentdata(){
    if(this._currentData){
      this._currentData.model = null;

    }
  }

}
